import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { reduxForm, formValueSelector } from 'redux-form';
import { Modal, Button, FormGroup, ControlLabel, DropdownButton, MenuItem, Collapse } from 'react-bootstrap';

import { find, first, range, padStart, delay, isString } from 'lodash';
import moment from 'moment';
import Fa from 'react-fontawesome';
import DateTimeDisplay from '../../../../components/date-time-display';

// Import Selectors
import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { requestUpdateOrganization } from '../../../Admin/AdminActions';
import { allContactGDPROptions, allSalesRepGDPROptions } from '../../../../util/helpers';

class OrganizationGDPRPage extends Component {
  constructor() {
    super();
    this.state = {
      showWarning: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectContactGDPR = this.selectContactGDPR.bind(this);
    this.selectSalesRepGDPR = this.selectSalesRepGDPR.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.manualSubmit = this.manualSubmit.bind(this);
    this.showWarning = this.showWarning.bind(this);
  }

  componentWillMount() {
    if (this.props.pristine) {
      this.initData();
    }
  }

  initData() {
    const { organization } = this.props;
    if (organization) {
      this.props.change('contact_gdpr_compliance', organization.contact_gdpr_compliance);
      this.props.change('sales_rep_gdpr_compliance', organization.sales_rep_gdpr_compliance);
    }
  }

  handleSubmit(data) {
    const { organization } = this.props;
    const params = {
      contact_gdpr_compliance: data.contact_gdpr_compliance,
      sales_rep_gdpr_compliance: data.sales_rep_gdpr_compliance,
    };
    return this.props.dispatch(requestUpdateOrganization(organization._id, params));
  }

  manualSubmit() {
    this.setState({ showWarning: false });
    const submitter = this.props.handleSubmit(this.handleSubmit);
    delay(submitter, 500); // submits
  }

  selectContactGDPR(v) {
    this.props.change('contact_gdpr_compliance', v);
  }
  selectSalesRepGDPR(v) {
    this.props.change('sales_rep_gdpr_compliance', v);
  }

  closeModal() {
    this.setState({ showWarning: false });
    this.initData();
  }

  showWarning() {
    const { organization, selectedContactGDPRCompliance, selectedSalesRepGDPRCompliance } = this.props;
    const hasChange = selectedSalesRepGDPRCompliance !== organization.sales_rep_gdpr_compliance ||
      selectedContactGDPRCompliance !== organization.contact_gdpr_compliance;
    if (hasChange) {
      this.setState({ showWarning: true });
    }
  }

  renderForm() {
    const {
      handleSubmit, submitting, organization,
      selectedContactGDPRCompliance,
      selectedSalesRepGDPRCompliance,
    } = this.props;

    const selectedContactOption = find(allContactGDPROptions, { value: selectedContactGDPRCompliance }) || first(allContactGDPROptions);
    const selectedSalesRepOption = find(allSalesRepGDPROptions, { value: selectedSalesRepGDPRCompliance }) || first(allSalesRepGDPROptions);
    const cursor = submitting ? 'not-allowed' : 'pointer';

    const hasChange = selectedSalesRepGDPRCompliance !== organization.sales_rep_gdpr_compliance ||
      selectedContactGDPRCompliance !== organization.contact_gdpr_compliance;

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="panel panel-default">
          <div className="panel-heading">
            GDPR Compliance Settings:
          </div>

          <div className="panel-body">
            <FormGroup>
              <ControlLabel>Contact GDPR Compliance Settings:</ControlLabel>
              <table className="table table-condensed table-borderless">
                <tbody>
                  {allContactGDPROptions.map((opt) => {
                    const isChecked = selectedContactOption !== undefined && opt.value === selectedContactOption.value;
                    let cls = isChecked ? 'text-success' : '';
                    let faName = isChecked ? 'check-circle' : 'circle-o';
                    let spin = false;
                    if (submitting) {
                      spin = true;
                      cls = 'text-muted';
                      if (isChecked) {
                        faName = 'spinner';
                      }
                    }
                    return (
                      <tr
                        style={{ cursor }}
                        key={opt.value}
                        onClick={() => {
                          if (!submitting) {
                            this.selectContactGDPR(opt.value);
                          }
                        }}
                      >
                        <td style={{ width: 20 }}>
                          <Fa
                            name={faName}
                            className={cls}
                            spin={spin}
                          />
                        </td>
                        <td>
                          <ControlLabel style={{ cursor }}>
                            <strong>{opt.label}</strong>
                          </ControlLabel>
                          <Collapse in={isChecked}>
                            <div>
                              <small>{opt.text}</small>
                            </div>
                          </Collapse>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </FormGroup>
            <hr />
            <FormGroup>
              <ControlLabel>Sales Rep GDPR Compliance Settings:</ControlLabel>
              <table className="table table-condensed table-borderless">
                <tbody>
                  {allSalesRepGDPROptions.map((opt) => {
                    const isChecked = selectedSalesRepOption !== undefined && opt.value === selectedSalesRepOption.value;
                    let cls = isChecked ? 'text-success' : '';
                    let faName = isChecked ? 'check-circle' : 'circle-o';
                    let spin = false;
                    if (submitting) {
                      spin = true;
                      cls = 'text-muted';
                      if (isChecked) {
                        faName = 'spinner';
                      }
                    }
                    return (
                      <tr
                        style={{ cursor }}
                        key={opt.value}
                        onClick={() => {
                          if (!submitting) {
                            this.selectSalesRepGDPR(opt.value);
                          }
                        }}
                      >
                        <td style={{ width: 20 }}>
                          <Fa
                            name={faName}
                            className={cls}
                            spin={spin}
                          />
                        </td>
                        <td>
                          <ControlLabel style={{ cursor }}>
                            <strong>{opt.label}</strong>
                          </ControlLabel>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </FormGroup>
          </div>
          <div className="panel-footer text-right">
            <Button disabled={!hasChange} bsStyle="primary" onClick={this.showWarning}>
              Update Settings
            </Button>
          </div>
        </div>

        <div style={{ height: 200 }} />
      </form>
    );
  }

  renderModal() {
    const { organization, selectedContactGDPRCompliance, selectedSalesRepGDPRCompliance } = this.props;
    const syncContacts = selectedContactGDPRCompliance !== organization.contact_gdpr_compliance;
    const syncSalesReps = selectedSalesRepGDPRCompliance !== organization.sales_rep_gdpr_compliance;

    return (
      <Modal show={this.state.showWarning} onHide={this.closeModal}>
        <Modal.Header closeButton>
          <div>Your change requires resync data for:</div>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {syncContacts && <li>Contacts</li>}
            {syncSalesReps && <li>Sales Reps</li>}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <Button bsStyle="link" onClick={this.closeModal}>Cancel</Button>
            <Button bsStyle="primary" onClick={this.manualSubmit}>Resync Data</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { organization } = this.props;
    const isDemo = organization && organization.is_demo;
    return (
      <div>
        <Helmet title="Sync Settings | Organization Setup" />
        <div className="container">
          {!isDemo && this.renderForm()}
          {!isDemo && this.renderModal()}
          {isDemo && <div className="alert alert-warning">
            This is a demo organization. You cannot schedule sync time to it.
          </div>}
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('organizationGDPRForm'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    organization: getUserCurrentOrganization(state),
    selectedContactGDPRCompliance: selector(state, 'contact_gdpr_compliance'),
    selectedSalesRepGDPRCompliance: selector(state, 'sales_rep_gdpr_compliance'),
  };
}

OrganizationGDPRPage.propTypes = {
  user: PropTypes.object.isRequired,
  organization: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  selectedContactGDPRCompliance: PropTypes.string,
  selectedSalesRepGDPRCompliance: PropTypes.string,
  change: PropTypes.func,
};

OrganizationGDPRPage.defaultProps = {
  selectedGDPRCompliance: null,
  selectedSalesRepGDPRCompliance: null,
};

OrganizationGDPRPage.contextTypes = {
  router: PropTypes.object,
};

const OrganizationGDPRForm = reduxForm({
  form: 'organizationGDPRForm',
})(OrganizationGDPRPage);

export default connect(mapStateToProps)(OrganizationGDPRForm);
